<div class="min-h-screen bg-gray-50 font" *ngIf="applicant; else notFound">
  <div class="bg-white border-b border-gray-200">
    <div class="max-w-6xl mx-auto px-6 py-4">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-4">
          <button
            class="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded-md transition-colors"
            (click)="goBack()"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
            {{'CANDIDATES.BACK_TO_CANDIDATES' | translate}}
          </button>
          <div class="w-px h-6 bg-gray-200"></div>
          <div>
            <h1 class="text-2xl font-bold text-gray-900">{{'CANDIDATES.APPLICANT_DETAILS' | translate}}</h1>
            <p class="text-gray-600">{{'CANDIDATES.MANAGE_AND_REVIEW_JOB_APPLICATIONS' | translate}}</p>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <button 
            *ngIf="canRunBackgroundCheck()"
            (click)="openBackgroundCheckDialog()"
            [disabled]="isLoadingBackgroundCheck"
            class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
            <svg *ngIf="!isLoadingBackgroundCheck" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z">
              </path>
            </svg>
            <svg *ngIf="isLoadingBackgroundCheck" class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
            </svg>
            {{'BACKGROUND_CHECK.RUN_BUTTON' | translate}}
          </button>
          <span 
            *ngIf="backgroundCheckStatus && !canRunBackgroundCheck()"
            class="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium"
            [ngClass]="getBackgroundCheckStatusClass()">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z">
              </path>
            </svg>
            {{'BACKGROUND_CHECK.STATUS' | translate}}: {{ getBackgroundCheckStatusLabel() }}
          </span>
          <button class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors bg-blue-600  hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed w-[172px]"
            [disabled]="isMovingToInterview || applicant.status.id == 3"
            (click)="moveToInterview(applicant)"
          >
            <svg *ngIf="!isMovingToInterview" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z">
              </path>
            </svg>

            <svg *ngIf="isMovingToInterview" class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10"
                      stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
            </svg>

            <span>
              {{ isMovingToInterview ? ('COMMON.LOADING' | translate) : ('CANDIDATES.MOVE_TO_INTERVIEW' | translate) }}
            </span>
          </button>

        </div>
      </div>
    </div>
  </div>

  <div class="max-w-6xl mx-auto px-6 py-8">
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
      <div class="lg:col-span-2 space-y-6">
        <div class="bg-white rounded-xl border border-gray-200 shadow-sm">
          <div class="p-6">
            <div class="flex items-start justify-between">
              <div class="flex items-center gap-4">
                <div class="w-16 h-16 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
                  <img
                    *ngIf="applicant.profilePicture?.url; else placeholder"
                    [src]="applicant.profilePicture?.url"
                    alt="{{applicant.firstName}} {{applicant.lastName}}"
                    class="w-full h-full object-cover"
                  />
                  <ng-template #placeholder>
                    <span class="text-white text-xl font-semibold">
                      {{ applicant.firstName?.charAt(0) || '?' }}
                    </span>
                  </ng-template>
                </div>
                <div>
                  <h2 class="text-xl font-semibold text-gray-900">{{applicant.firstName}} {{applicant.lastName}}</h2>
                  <!-- <p class="text-gray-600">{{applicant.position}}</p> -->
                  <div class="flex items-center gap-4 mt-2">
                    <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium" [ngClass]="getStatusClass(applicant.status?.name)">
                      {{applicant.status.name | titlecase}}
                    </span>
                    <div class="flex items-center gap-1 text-sm text-gray-500">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                      </svg>
                      {{'CANDIDATES.APPLIED' | translate}} {{formatDate(applicant.created)}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 pb-6">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div class="flex items-center gap-3">
                <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
                <div>
                  <p class="text-sm font-medium text-gray-900">{{'CANDIDATES.EMAIL' | translate}}</p>
                  <p class="text-sm text-gray-600">{{applicant.emailAddress}}</p>
                </div>
              </div>
              <div class="flex items-center gap-3">
                <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                </svg>
                <div>
                  <p class="text-sm font-medium text-gray-900">{{'CANDIDATES.PHONE' | translate}}</p>
                  <p class="text-sm text-gray-600">{{applicant.phoneNumber}}</p>
                </div>
              </div>
              <div class="flex items-center gap-3">
                <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
                <div>
                  <p class="text-sm font-medium text-gray-900">{{'CANDIDATES.LOCATION' | translate}}</p>
                  <p class="text-sm text-gray-600">
                    {{applicant?.streetAddress}}, {{applicant?.city}}, {{applicant?.state}} {{applicant?.zipCode}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-white rounded-xl border border-gray-200 shadow-sm">
          <div class="p-6 border-b border-gray-200">
            <h2 class="text-lg font-semibold text-gray-900 flex items-center gap-2">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path>
              </svg>

              {{'CANDIDATES.EXPERIENCE_SKILLS' | translate}}
            </h2>
          </div>
          <div class="p-6 space-y-4">
            <div>
              <h4 class="font-medium text-gray-900 mb-2">{{'CANDIDATES.PROFESSIONAL_EXPERIENCE' | translate}}</h4>
              <p class="text-gray-600">{{applicant.jobApplicationSections[0].jobApplicationSectionProperties[4]?.stringValue}}</p>
            </div>
            <div>
              <h4 class="font-medium text-gray-900 mb-2" *ngIf="getCandidateSkillsTags().length > 0">{{'CANDIDATES.SKILLS' | translate}}</h4>
              <div class="flex flex-wrap gap-2" *ngIf="getCandidateSkillsTags().length > 0">
                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" *ngFor="let skill of getCandidateSkillsTags()">
                  {{skill}}
                </span>
              </div>

            </div>

            <div class="flex items-center gap-2">
              <h4 class="font-medium text-gray-900 inline-flex">{{'CANDIDATES.APPLICATION_VIDEO' | translate}}</h4>
              <button *ngIf="applicant.applicationVideo?.url"
                  class="p-2 text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-lg transition-colors group"
                  title="{{ 'CANDIDATES.VIEW_VIDEO_APPLICATION' | translate }}" (click)="viewVideoApplication(applicant)">
                  <div class="relative">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-video w-5 h-5">
                      <path d="m22 8-6 4 6 4V8Z"></path>
                      <rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-play w-2 h-2 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                      <polygon points="5 3 19 12 5 21 5 3"></polygon>
                    </svg>
                  </div>
                </button>

            </div>
          </div>
        </div>

<!-- Dynamic Additional Sections -->
<div class="bg-white rounded-xl border border-gray-200 shadow-sm" *ngIf="getDynamicSections().length > 0">
  <div class="p-6 border-b border-gray-200">
    <h2 class="text-lg font-semibold text-gray-900 flex items-center gap-2">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      {{'CANDIDATES.ADDITIONAL_INFORMATION' | translate}}
    </h2>
  </div>
  <div class="p-6 space-y-6">
    <ng-container *ngFor="let section of getDynamicSections(); let last = last">
      <div class="space-y-4">
        <h3 class="text-md font-semibold text-gray-900">{{section.name}}</h3>
        <p class="text-sm text-gray-600" *ngIf="section.description">{{section.description}}</p>
        
        <div class="space-y-3">
          <ng-container *ngFor="let property of section.jobApplicationSectionProperties">
            <div *ngIf="property.stringValue || property.integerValue || property.dateTimeValue || property.booleanValue !== null">
              <h4 class="text-sm font-medium text-gray-900 mb-1">{{property.label}}</h4>

              <!-- Handle text, email, number, phone, and any other string-based types -->
              <div *ngIf="['text', 'email', 'number', 'phone'].includes(property.type) && property.stringValue">
                <p class="text-sm text-gray-600">{{property.stringValue}}</p>
              </div>

              <!-- Textarea -->
              <div *ngIf="property.type === 'textarea' && property.stringValue">
                <p class="text-sm text-gray-600 whitespace-pre-line">{{property.stringValue}}</p>
              </div>
              
              <!-- About-textarea (experience) -->
              <div *ngIf="property.type === 'about-textarea' && property.stringValue">
                <p class="text-sm text-gray-600">{{property.stringValue}}</p>
              </div>

              <!-- Select -->
              <div *ngIf="property.type === 'select' && property.stringValue">
                <p class="text-sm text-gray-600">{{property.stringValue}}</p>
              </div>
              
              <!-- Checkbox -->
              <div *ngIf="property.type === 'checkbox' && property.stringValue">
                <div class="space-y-1">
                  <div *ngFor="let option of property.options" class="flex items-center gap-2">
                    <svg *ngIf="isOptionSelected(property.stringValue, option)" class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <svg *ngIf="!isOptionSelected(property.stringValue, option)" class="w-4 h-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                    <span class="text-sm text-gray-700">{{option}}</span>
                  </div>
                </div>
              </div>
              
              <!-- Radio with Yes/No styling -->
              <div *ngIf="property.type === 'radio' && property.stringValue">
                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                      [ngClass]="{
                        'bg-green-100 text-green-800': property.stringValue === 'Yes',
                        'bg-red-100 text-red-800': property.stringValue === 'No',
                        'bg-gray-100 text-gray-800': property.stringValue !== 'Yes' && property.stringValue !== 'No'
                      }">
                  {{property.stringValue}}
                </span>
              </div>
              
              <!-- Tags -->
              <div *ngIf="property.type === 'tags' && property.stringValue">
                <div class="flex flex-wrap gap-2">
                  <span *ngFor="let tag of getTagsArray(property.stringValue)" 
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                    {{tag}}
                  </span>
                </div>
              </div>

              <!-- Date -->
              <div *ngIf="property.type === 'date' && property.dateTimeValue">
                <p class="text-sm text-gray-600">{{property.dateTimeValue | date:'medium'}}</p>
              </div>
              
              <!-- File (no upload) -->
              <div *ngIf="['file', 'video'].includes(property.type) && !property.stringValue">
                <p class="text-sm text-gray-400 italic">{{'CANDIDATES.NO_FILE_UPLOADED' | translate}}</p>
              </div>
              
              <!-- File with download link -->
              <div *ngIf="property.type === 'file' && property.stringValue">
                <a [href]="property.stringValue" target="_blank" 
                   class="inline-flex items-center gap-1 text-sm text-blue-600 hover:text-blue-700 hover:underline">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"></path>
                  </svg>
                  {{'CANDIDATES.DOWNLOAD_FILE' | translate}}
                </a>
              </div>
              
              <!-- Video -->
              <div *ngIf="property.type === 'video' && property.stringValue">
                <div class="relative">
                  <video [src]="property.stringValue" controls class="w-full rounded-lg"></video>
                </div>
              </div>
            </div>
            
            <div *ngIf="!property.stringValue && property.integerValue === null && property.dateTimeValue === null && property.booleanValue === null" 
                 class="text-sm text-gray-400 italic">
              {{'CANDIDATES.NO_RESPONSE' | translate}}
            </div>
          </ng-container>
        </div>
      </div>
      <div class="border-t border-gray-200" *ngIf="!last"></div>
    </ng-container>
  </div>
</div>
      </div>

      <div class="space-y-6">
        <!-- Background Check Status Card -->
        <div class="bg-white rounded-xl border border-gray-200 shadow-sm">
          <div class="p-6 border-b border-gray-200">
            <h2 class="text-lg font-semibold text-gray-900 flex items-center gap-2">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z">
                </path>
              </svg>
              {{'BACKGROUND_CHECK.SECTION_TITLE' | translate}}
            </h2>
          </div>
          <div class="p-6">
            <!-- Loading State -->
            <div *ngIf="isLoadingBackgroundCheck" class="flex items-center justify-center py-4">
              <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
            </div>
            
            <!-- No Background Check -->
            <div *ngIf="!isLoadingBackgroundCheck && !backgroundCheckStatus" class="text-center py-4">
              <div class="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-3">
                <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z">
                  </path>
                </svg>
              </div>
              <p class="text-sm text-gray-500 mb-4">{{'BACKGROUND_CHECK.NOT_STARTED' | translate}}</p>
              <button 
                (click)="openBackgroundCheckDialog()"
                class="w-full inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                </svg>
                {{'BACKGROUND_CHECK.RUN_BUTTON' | translate}}
              </button>
            </div>
            
            <!-- Background Check Exists -->
            <div *ngIf="!isLoadingBackgroundCheck && backgroundCheckStatus" class="space-y-4">
              <div class="flex items-center justify-between">
                <span class="text-sm text-gray-600">{{'BACKGROUND_CHECK.STATUS' | translate}}</span>
                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                      [ngClass]="getBackgroundCheckStatusClass()">
                  {{ getBackgroundCheckStatusLabel() }}
                </span>
              </div>
              <div class="flex items-center justify-between" *ngIf="backgroundCheckStatus.invitationId">
                <span class="text-sm text-gray-600">Order ID</span>
                <span class="text-sm font-mono text-gray-900">{{ backgroundCheckStatus.invitationId }}</span>
              </div>
              <div class="flex items-center justify-between">
                <span class="text-sm text-gray-600">Initiated</span>
                <span class="text-sm text-gray-900">{{ formatDate(backgroundCheckStatus.createdAt) }}</span>
              </div>
              <div class="flex items-center justify-between" *ngIf="backgroundCheckStatus.completedAt">
                <span class="text-sm text-gray-600">Completed</span>
                <span class="text-sm text-gray-900">{{ formatDate(backgroundCheckStatus.completedAt) }}</span>
              </div>
              <div *ngIf="backgroundCheckStatus.status === 'Completed' && backgroundCheckStatus.searchResults && backgroundCheckStatus.searchResults.length > 0" class="mt-4 border-t pt-4">
                <div class="flex items-center justify-between mb-3">
                  <span class="text-sm font-medium text-gray-700">Results Summary</span>
                </div>
                <div class="space-y-2">
                  <div *ngFor="let result of backgroundCheckStatus.searchResults" class="flex items-start justify-between p-2 bg-gray-50 rounded">
                    <div class="flex-1">
                      <p class="text-sm font-medium text-gray-900">{{ result.searchName }}</p>
                      <p *ngIf="result.notes" class="text-xs text-gray-500">{{ result.notes }}</p>
                    </div>
                    <div class="flex items-center gap-2">
                      <span class="text-xs font-medium text-gray-600">
                        {{ getResultText(result) }}
                      </span>
                      <svg *ngIf="shouldShowCheckmark(result)" class="w-4 h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="backgroundCheckStatus.failureReason" class="mt-3 p-3 bg-red-50 rounded-lg">
                <p class="text-sm text-red-700">{{ backgroundCheckStatus.failureReason }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Quick Actions -->
        <div class="bg-white rounded-xl border border-gray-200 shadow-sm">
          <div class="p-6 border-b border-gray-200">
            <h2 class="text-lg font-semibold text-gray-900">{{'CANDIDATES.QUICK_ACTIONS' | translate}}</h2>
          </div>
          <div class="p-6 space-y-3">
            <button class="w-full flex items-center justify-start gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" (click)="moveToInterview(applicant)" [disabled]="isMovingToInterview || applicant.status.id == 3">
              <svg *ngIf="!isMovingToInterview" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <svg *ngIf="isMovingToInterview" class="w-4 h-4 animate-spin text-gray-600" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10"
                        stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
              </svg>
              <span>
                {{ isMovingToInterview ? ('COMMON.LOADING' | translate) : ('CANDIDATES.MOVE_TO_INTERVIEW' | translate) }}
              </span>
            </button>

            <button class="w-full flex items-center justify-start gap-2 px-4 py-2 text-sm font-medium text-red-600 bg-white border border-gray-300 rounded-lg hover:bg-red-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" (click)="rejectApplication(applicant)" [disabled]="isRejecting || applicant.status.id == 6">
            <svg *ngIf="!isRejecting" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
            </svg>
            <svg *ngIf="isRejecting" class="w-4 h-4 animate-spin text-red-600" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10"
                      stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
            </svg>
            <span>
              {{ isRejecting ? ('COMMON.LOADING' | translate) : ('CANDIDATES.REJECT_APPLICATION' | translate) }}
            </span>
          </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #notFound>
  <div class="min-h-screen bg-gray-50 p-6 font">
    <div class="max-w-4xl mx-auto">
      <div class="text-center">
        <h1 class="text-2xl font-bold text-gray-900 mb-4">{{'CANDIDATES.APPLICANT_NOT_FOUND' | translate}}</h1>
        <button class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" (click)="goBack()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
          {{'CANDIDATES.BACK_TO_CANDIDATES' | translate}}
        </button>
      </div>
    </div>
  </div>
</ng-template>